import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { CHUNK_RELOAD_SESSION_KEY } from '@/utils/lazy-with-retry';
import { applyStagingDocumentChrome } from '@/lib/staging-environment';
import './index.css';

// Clear one-shot deploy recovery flag after a successful boot.
sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);

// Hostname-gated title + favicon. No-op on production hosts ([STG-CHROME-1]).
applyStagingDocumentChrome();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);